export default __webpack_public_path__ + "static/media/step_2.40e479f9.svg";